import enums from '@/helpers/enums';

const months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
]

const monthsInNumbers = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12"
]

function getRangeOfDatesByYears(maxYears) {
    let currentDate = new Date();
    let range = [];

    var pastDate = new Date(currentDate);
    pastDate.setDate(pastDate.getDate() - maxYears);

    range = [convertDateToString(pastDate), convertDateToString(currentDate)]

    return range;
}

function getCurrentDate() {
    var today = new Date();
    var month = today.getMonth() + 1; //months from 1-12
    var day = today.getDate();
    var year = today.getFullYear();

    if (month.toString().length < 2)
        month = '0' + month;
    if (day.toString().length < 2)
        day = '0' + day;

    return `${year}-${month}-${day}`;
}

function convertDateToString(date) {
    var month = date.getMonth() + 1; //months from 1-12
    var day = date.getDate();
    var year = date.getFullYear();

    if (month.toString().length < 2)
        month = '0' + month;
    if (day.toString().length < 2)
        day = '0' + day;

    return `${year}-${month}-${day}`;
}

function getRangeOfYears(maxYears) {
    let date = new Date();
    let years = [];

    let currentYear = date.getFullYear();
    let startYear = currentYear - maxYears;

    while (startYear <= currentYear) {
        let year = startYear++;
        years.push(year.toString());
    }

    return years.reverse();
}

function getDaysByYearAndMonth(year, month) {
    let date = new Date(year, month - 1, 1);
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    let currentMonth = (currentDate.getMonth() + 1);
    let currentDay = currentDate.getDate();

    let result = [];
    let day = 0;

    if (parseInt(year) == currentYear && parseInt(month) == currentMonth) {
        for (let index = currentDay; index <= (new Date(year).getDate()); index++) {
            day = index;

            if (day.toString().length <= 1)
                day = `0${day}`;

            result.push(day.toString());
        }
    } else {
        while (date.getMonth() == month - 1) {
            day = date.getDate();

            if (day.toString().length <= 1)
                day = `0${day}`;

            result.push(day.toString());
            date.setDate(date.getDate() + 1);
        }
    }
    return result;
}

function getMonthsOfYearInLetters(yearSelected) {
    let date = new Date();
    let numericMonths = [];
    let stringMonths = [];

    let currentYear = date.getFullYear();
    //let currentMonth = (date.getMonth() + 1);
    if (parseInt(yearSelected) == currentYear) {
        for (let index = 1; index <= 12; index++) {
            let month = index;
            if (index.toString().length < 2) {
                month = `0${index}`
            }
            numericMonths.push(month.toString());
        }
        if (numericMonths.length > 0)
            numericMonths.forEach(e => stringMonths.push(enums.largeMonths[e]));
    } else {
        stringMonths = months;
    }
    return stringMonths;
}

function getMonthsOfYearInNumbers(yearSelected) {
    let date = new Date();
    let numericMonths = [];

    let firstMonthOfYear = 1;
    let currentYear = date.getFullYear();
    let currentMonth = (date.getMonth() + 1);

    if (parseInt(yearSelected) == currentYear) {
        while (firstMonthOfYear <= currentMonth) {
            let month = firstMonthOfYear++;
            if (month.toString().length < 2) {
                month = `0${month}`
            }
            numericMonths.push(month.toString());
        }
    } else {
        numericMonths = monthsInNumbers;
    }

    return numericMonths;
}

function createDateStringByYearMonthDay(year, month, day) {
    let date = `${year}-${month}-${day}`;
    return date;
}

function getAge(stringDate) {
    let date = new Date();
    let stringDateSplit = stringDate.split('-');
    let currentYear = date.getFullYear();
    let currentMonth = (date.getMonth() + 1);
    let currentDay = date.getDate();

    let age = currentYear - parseInt(stringDateSplit[0]);

    if (parseInt(stringDateSplit[1]) > currentMonth) {
        age--;
    }

    if (parseInt(stringDateSplit[1]) == currentMonth) {
        if (parseInt(stringDateSplit[2]) > currentDay) {
            age--;
        }
    }

    return age;
}

function isUnderAge(age, minAge) {
    return age >= minAge ? false : true;
}


function getRangeOfYearsFuture(maxYears) {
    let date = new Date();
    let years = [];

    let currentYear = date.getFullYear();
    let startYear = currentYear + maxYears;

    while (currentYear <= startYear) {
        let year = startYear--;
        years.push(year.toString());
    }

    return years.reverse();
}

function getAllDaysByYearAndMonth(year, month) {
    let date = new Date(year, month - 1, 1);
    let result = [];
    let day = 0;

    while (date.getMonth() == month - 1) {
        day = date.getDate();

        if (day.toString().length <= 1)
            day = `0${day}`;

        result.push(day.toString());
        date.setDate(date.getDate() + 1);
    }
    return result;
}

function getMonths() {
    return months;
}

function getMonthsInNumbers() {
    return monthsInNumbers;
}

export {
    getRangeOfDatesByYears,
    getCurrentDate,
    convertDateToString,
    getRangeOfYears,
    getDaysByYearAndMonth,
    getMonthsOfYearInLetters,
    createDateStringByYearMonthDay,
    getMonthsOfYearInNumbers,
    getAge,
    isUnderAge,
    getRangeOfYearsFuture,
    getAllDaysByYearAndMonth,
    getMonths,
    getMonthsInNumbers
}